export async function apiFetch(url: string, options: RequestInit = {}) {
    const resp = await fetch(url, {
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            ...(options.headers || {})
        },
        ...options
    });

    if (resp.status === 403) {
        window.location.href = "/403";
        throw new Error("Forbidden");
    }

    return resp;
}
